import { _ as _objectWithoutProperties, d as _objectSpread2, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { L as Label } from '../index-c4501d32.js';

var styles = {
raw: ".hcr-select-1-6-0{position:relative}.hcr-select--error-1-6-0:before,.hcr-select--valid-1-6-0:before{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;position:absolute;top:10px;right:49px;z-index:1}@media (min-width:1200px){.hcr-select--error-1-6-0:before,.hcr-select--valid-1-6-0:before{top:30px}}@media (min-width:1200px){.hcr-select--no-label-1-6-0:before{top:6px}}.hcr-select--error-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M500 90.9A409.1 409.1 0 10909.1 500 409.1 409.1 0 00500 90.9zm-28.2 150a28.2 28.2 0 0156.4 0v373.6a28.2 28.2 0 11-56.4 0zM500 803.6a45.5 45.5 0 1145.5-45.4 45.5 45.5 0 01-45.5 45.4z' fill='rgba(255, 87, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-select--valid-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M500 90.9A409.1 409.1 0 10909.1 500 409.1 409.1 0 00500 90.9zm257.3 276.4L460 664.5a23.6 23.6 0 01-15.9 6.4 22.7 22.7 0 01-15.9-6.4L242.7 479.1a22.3 22.3 0 010-31.4 21.8 21.8 0 0131.8 0l169.6 169.1 283.2-281.3a22.3 22.3 0 1131.8 31.8z' fill='rgba(115, 215, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-select-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M236.4 365.9a28.2 28.2 0 0140.4 0l216.4 216.4a8.2 8.2 0 0013.6 0l216.4-216.4a28.6 28.6 0 0140.4 40.5L545.5 622.7a66.4 66.4 0 01-45.5 19.6 66.4 66.4 0 01-45.5-19.6L236.4 406.4a28.2 28.2 0 010-40.5z' fill='rgba(139, 139, 139, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;position:absolute;top:10px;right:12px;pointer-events:none}@media (min-width:1200px){.hcr-select-1-6-0:after{top:30px}}.hcr-select--valid-1-6-0 .hcr-select__field-1-6-0{padding-right:80px}.hcr-select--error-1-6-0 .hcr-select__field-1-6-0{padding-right:80px;border:1px solid #ff5700}.hcr-select--active-1-6-0 .hcr-select__field-1-6-0{border:1px solid #757575;outline:none}.hcr-select--disabled-1-6-0 .hcr-select__field-1-6-0{cursor:not-allowed;opacity:.5}@media (min-width:1200px){.hcr-select--no-label-1-6-0:after{top:6px}}.hcr-select__field-1-6-0{font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;position:relative;width:100%;height:44px;border:1px solid #c8c8c8;border-radius:5px;background-color:#fff;color:#444;line-height:1.375em;text-overflow:ellipsis;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0 48px 0 12px;background:transparent}@media (min-width:1200px){.hcr-select__field-1-6-0{height:36px}}.hcr-select__field-1-6-0::-webkit-input-placeholder{color:#757575;font-style:italic}.hcr-select__field-1-6-0::-moz-placeholder{color:#757575;font-style:italic}.hcr-select__field-1-6-0:-ms-input-placeholder{color:#757575;font-style:italic}.hcr-select__field-1-6-0::-ms-input-placeholder{color:#757575;font-style:italic}.hcr-select__field-1-6-0::placeholder{color:#757575;font-style:italic}.hcr-select__field-1-6-0:active,.hcr-select__field-1-6-0:focus,.hcr-select__field-1-6-0:hover{outline:0}.hcr-select__field-1-6-0::-ms-expand{display:none}.hcr-select__field-1-6-0:focus{border:1px solid #757575;outline:none}.hcr-select__field-1-6-0[disabled]{cursor:not-allowed;opacity:.5}.hcr-select__info-1-6-0{color:#444;font-size:14px;font-weight:300;line-height:17px;display:block;padding-top:3px}.hcr-select--error-1-6-0 .hcr-select__info-1-6-0{color:#c64300}",
map:{"hcr-select":"hcr-select-1-6-0","hcr-select--error":"hcr-select--error-1-6-0","hcr-select--valid":"hcr-select--valid-1-6-0","hcr-select--no-label":"hcr-select--no-label-1-6-0","hcr-select__field":"hcr-select__field-1-6-0","hcr-select--active":"hcr-select--active-1-6-0","hcr-select--disabled":"hcr-select--disabled-1-6-0","hcr-select__info":"hcr-select__info-1-6-0"}};

var bem = Bem('select', styles);
var Select = function Select(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      extraClasses = _ref.extraClasses,
      id = _ref.id,
      label = _ref.label,
      valid = _ref.valid,
      requiredText = _ref.requiredText,
      options = _ref.options,
      info = _ref.info,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, ["active", "disabled", "extraClasses", "id", "label", "valid", "requiredText", "options", "info", "placeholder"]);

  // traverse options and create array of child elements
  var opts = []; // Add Placeholder as fist item in options if provided as prop

  if (placeholder) {
    opts.push(React.createElement("option", {
      key: "placeholder",
      value: "",
      style: {
        display: 'none'
      }
    }, placeholder));
  }

  for (var i = 0; i < options.length; i += 1) {
    // deconstruct the object to assign all optional props as ...restProps
    var _options$i = _objectSpread2({}, options[i]),
        value = _options$i.value,
        displayValue = _options$i.displayValue,
        key = _options$i.key,
        optProps = _objectWithoutProperties(_options$i, ["value", "displayValue", "key"]); // crate option elements


    opts.push(React.createElement("option", _extends({
      key: key || value,
      value: value
    }, optProps), displayValue || value));
  }

  var blockClass = bem.b({
    valid: valid === true,
    error: valid === false,
    disabled: disabled,
    active: active,
    'no-label': !label
  }, extraClasses);
  return React.createElement("div", {
    className: blockClass
  }, label && React.createElement(Label, {
    extraClasses: bem.e('label'),
    text: label,
    labelFor: id,
    requiredText: requiredText
  }), React.createElement("select", _extends({
    id: id,
    className: bem.e('field'),
    required: _objectSpread2({}, rest).required || requiredText && requiredText.length >= 1,
    disabled: disabled
  }, rest), opts), info && React.createElement("span", {
    className: bem.e('info')
  }, info));
};
Select.displayName = 'Select';
Select.defaultProps = {
  active: null,
  disabled: null,
  extraClasses: '',
  requiredText: null,
  valid: null,
  info: null,
  placeholder: null
};
Select.propTypes = {
  /** Sets active state */
  active: PropTypes.bool,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Injection in className */
  disabled: PropTypes.bool,

  /** Id for this select box, also used "for" label */
  id: PropTypes.string.isRequired,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Options for this select box */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })).isRequired,

  /** Marks the element as required, adds specified text to label text */
  requiredText: PropTypes.string,

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** Provides extra information for this select field */
  info: PropTypes.string,

  /** Adds a placeholder value which is not selectable */
  placeholder: PropTypes.string
};
var Select$1 = Injecss(Select, styles);

export { Select$1 as Select };
